<template>
  <div class="productInfo">
    <div>
      <div class="productInfoTitle">
        <p>Условия займа</p>
        <p>ONLINE</p>
      </div>
      <p class="productDescription" v-show="isOnline">Деньги поступят вам на карту после<br> одобрения заявки</p>
      <p class="productDescription" v-show="!isOnline">Деньги поступят на ваш расчетный счет после дополнительного общения с персональным менеджером</p>
      <div class="productTable" v-show="isOnline">
        <div>
          <p>Время ожидания:</p>
          <p>до 15 минут</p>
        </div>
        <div>
          <p>Вы получите:</p>
          <p>{{getSelectedDeal.Amount | moneyFormat}} ₽</p>
        </div>
        <div>
          <p>Дата возврата:</p>
          <p>{{getSelectedDeal.payDay}}</p>
        </div>
        <div>
          <p>Вы вернёте:</p>
          <p>{{getSelectedDeal.OutPayments | moneyFormat}} ₽</p>
        </div>
      </div>
      <div class="productTable" v-show="!isOnline">
        <div>
          <p>Время ожидания:</p>
          <p>До 24 часов</p>
        </div>
        <div>
          <p>Вы получите:</p>
          <p>{{getSelectedDeal.Amount | moneyFormat}} ₽</p>
        </div>
        <div>
          <p>На срок:</p>
          <p>{{getSelectedDeal.loanPeriod}} {{getSelectedDeal.PeriodType}}</p>
        </div>
        <div>
          <p>Еженедельный платёж составит:</p>
          <p>{{getSelectedDeal.FixedPay | moneyFormat}} ₽</p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
// import {mapState,mapGetters} from 'vuex';

export default {
  name:'productInfo',
  computed:{
    ...mapGetters([
      'getSelectedDeal',
        // 'getActiveDistinctAmount',
        // 'getActiveMinDeal',
        // 'getActiveMaxDeal',
        // 'getActiveDistinctPeriod',
        // 'getActiveCalcSummIndex',
        // 'getActiveCalcWeekIndex'
    ]),
    //   ...mapState({
    //     valueVuex: state => state.Form.sendData,
    //   }),
    isOnline() {
      return this.getSelectedDeal.vwIsPdl === '1';
    },
  }
}
</script>

<style>

.productInfo { background-color: var(--color-dark-green); width: calc(100% - var(--font-size-20) * 2 ); border-radius: 10px; padding: var(--font-size-25) var(--font-size-20); border-radius:  var(--font-size-20);}
.productInfo > div {background-color: white;padding: var(--font-size-20);border-radius: inherit;}

.productInfoTitle {display: flex;align-items: center;justify-content: space-between;padding-bottom: var(--font-size-20);border-bottom: 1px solid var(--color-dark-green)}
.productInfoTitle p {font-size: var(--font-size-24);font-weight: 700;}
.productInfoTitle p:last-child {color:white;background-color: var(--color-green);font-weight: 400;padding: 0 var(--font-size-10);}

.productDescription{padding: var(--font-size-10) 0;min-height: var(--font-size-60);}


.productTable{}
.productTable > div{display: flex;align-items: center;justify-content: space-between;margin: var(--font-size-10) 0;}
.productTable > div p:last-child{color:var(--color-dark-green)}


</style>